import { useTranslation } from "react-i18next";
import { AssessmentType } from "../../../api/main/models/codeOnly/AssessmentType";
import { SubscriptionAssessmentsListBase } from "../../subscriptionAssessments/SubscriptionAssessmentsListBase";
import { useParams } from "react-router";
import { DistributorEditNavigation } from './DistributorEditNavigation';

/**
 * List of actual assessments.
 */
export const DistributorAssessmentsList = () => {
    const { t } = useTranslation();

    const { subscriptionId } = useParams<{ subscriptionId: string }>();

    const baseRoute = '/administration/assessments';

    return (
        <SubscriptionAssessmentsListBase
            title={t('distributorAssessmentsList.title', 'Licensed assessments')}
            mobileColumn1Name={t('distributorAssessmentsList.mobileColumn1Name', 'Assessment')}
            assessmentTypes={[AssessmentType.Assessment]}
            baseRoute={baseRoute}
            navigationPills={<DistributorEditNavigation id={subscriptionId ?? ''} />}
        />
    );
};